import React from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import AttachmentIcon from '@atlaskit/icon/glyph/attachment';
import { token } from '@atlaskit/tokens';
import AKTooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type OwnProps = Record<any, any>;

export type StateProps = {
	isCommentAttachmentInProgress: boolean;
};

export type DispatchProps = {
	onClick: () => void;
};

export type Props = OwnProps & StateProps & DispatchProps;

const AttachmentPicker = (props: Props) => {
	const { onClick, isCommentAttachmentInProgress } = props;
	const { formatMessage } = useIntl();

	return (
		<Wrapper>
			<AKTooltip content={formatMessage(messages.addAttachmentLabel)} position="bottom">
				<Button
					spacing="none"
					appearance="subtle-link"
					// @ts-expect-error - TS2322 - Type '{ spacing: "none"; appearance: "subtle-link"; isLoading: boolean; iconBefore: Element; externalId: string; onClick: () => void; }' is not assignable to type 'IntrinsicAttributes & ButtonProps & RefAttributes<HTMLElement>'.
					isLoading={isCommentAttachmentInProgress}
					iconBefore={
						<IconWrapper>
							<AttachmentIcon size="medium" label={formatMessage(messages.addAttachmentLabel)} />
						</IconWrapper>
					}
					externalId="attachment"
					onClick={onClick}
					interactionName="auto-generated.jira-issue-view-servicedesk-editor-container.collapsed-editor-view.attachment-picker.button"
				/>
			</AKTooltip>
		</Wrapper>
	);
};

export default AttachmentPicker;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IconWrapper = styled.span({
	paddingTop: token('space.050', '4px'),
	paddingRight: token('space.050', '4px'),
	paddingBottom: token('space.050', '4px'),
	paddingLeft: token('space.050', '4px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	marginLeft: 'auto',
	marginRight: token('space.100', '8px'),
});
